import RewardSource from "@/api/RewardSource.js";
import UserSource from "@/api/UserSource.js";
import cookieStorage from "@/plugins/cookieStorage.js";

export const authModule = {
    state: () => ({
        accesses: {
            user_id: null,
        }
    }),
    mutations: {
        setToken(state, data) {
            if (data?.user_id) {
                cookieStorage.setItem('user_id', data.user_id);
                state.accesses.user_id = data.user_id;
            } else {
                cookieStorage.removeItem('user_id');
                state.accesses.user_id = null;
            }
        },
    },
    actions: {
        async logout({state, commit, dispatch}) {

            cookieStorage.removeItem('user_id');
            state.accesses = {};
            commit('setToken', {});
            commit('user/setUser', null, {root: true});
            dispatch('cart/removeAll', null, {root: true});

            await this.$API.manager.getSource(UserSource).logout().finally(async () => {
                await localStorage.removeItem('loginTimerStartAt');
                this.$router.push({name: 'index'})
            })

        },
        initCity({state}) {
            state.accesses.user_id = cookieStorage.getItem('user_id') ?? null;
        }
    },
    namespaced: true
}
